import { TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import 'date-fns'
import { MDBBtn, MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBContainer, MDBRow } from 'mdbreact'
import React, { useEffect, useState } from 'react'
// import { VisaeroJumbotron } from '../../Common/VisaeroJumbotron'
// import { parseISO } from 'date-fns';
import DateFnsUtils from '@date-io/date-fns'
import moment from 'moment'
import { useHistory } from 'react-router'
import axios from '../../../authAxios'


function EnquiryForm() {
    const [country, setCountry] = useState(localStorage.getItem('nationality'))
    const [countryArray, setCountryArray] = useState([]) // Not going to be required as we are disabling the nationality field
    const [city, setCity] = useState("")
    const [cityArray, setCityArray] = useState([])
    const [userDetails, setUserDetails] = useState({})
    const [reviewForm, setReviewForm] = useState([])
    const [reviewFormName, setReviewFormName] = useState('')
    const [branches, setBranches] = useState([])
    const [isDisplayBranch, setIsDisplayBranch] = useState(false)
    const [isDisabled, setIsDisabled] = useState(false)
    
    const history = useHistory()


    // based on user_type condition
    const getBranches = async () => {
        try {
            const res = await axios
                .get('/visa-admin/getBranches', {
                    params: {
                        host: localStorage.getItem('host'),
                        country: localStorage.getItem('nationality')
                    }
                })
            if (res.data?.data == "success") {
                setBranches(res.data?.dataobj)
                // console.log("get branches =>", res.data)
            } else {
                setBranches([])

            }
        } catch (err) {
            console.log(err)
            setBranches([])
        }
    }
    const validateDisable = () => {
        let checkErrArr = [...reviewForm]
        for (var i = 0; i < checkErrArr.length; i++) {
            if ((checkErrArr[i].validations.display && checkErrArr[i].validations.mandatory) && (checkErrArr[i].validations.hasErr == true || checkErrArr[i].value == "")) {
                setIsDisabled(true);
                // return;
                break
            } 
            else {
                setIsDisabled(false);
            }
        }
    }

    useEffect(() => {

        getReviewFormForStickerVisa()
        return () => {
            localStorage.removeItem('selected_visa_offer')
        }
    }, [])

    useEffect(() => {
        if (reviewForm) {
            validateDisable()
        }
    }, [reviewForm])

    const getReviewFormForStickerVisa = () => {
        // console.log(this.state.form_obj);
        // console.log("before fields load ...");
        // this.setState({ showAgreement: false })
        // console.log(localStorage.getItem('travelling_to_identity'))
        if (!localStorage.getItem('selected_visa_offer')) {
            history.push('/new-visa')
            return
        }
        axios
            .post('/visa/getReviewFormForStickerVisa', {
                // "applicant_id": app_id,
                "host": localStorage.getItem("host"),
                // "travelling_to_identity": 'UAE_IND_USA'
                "travelling_to_identity": localStorage.getItem('travelling_to_identity')
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then(res => {
                // console.log(res);
                // console.log(new Date())
                if (res.data.data == "success") {
                    let select_visa_offer = JSON.parse(localStorage.getItem('selected_visa_offer'))
                    let revwForm = res.data.dataobj?.visa_form.map((field, i) => {
                        if (field.type == 'dateControl') {
                            // console.log('date => ', select_visa_offer?.journey_end_date, " ", moment(select_visa_offer?.journey_end_date))
                            if (field?.name == 'departure_date') field.value = moment(select_visa_offer?.journey_start_date).format("YYYY-MM-DD")
                            if (field?.name == "return_date") field.value = moment(select_visa_offer?.journey_end_date).format("YYYY-MM-DD")

                        }
                        if (field.validations.display == true) {
                            field.validations.hasErr = ''
                            field.validations.errMsg = ''
                        }
                        return field
                    })
                    // let revwFormErr = res.data.dataobj?.visa_form.map((field, i) => {
                    //     if (field.type == 'dateControl') field.value = new Date()
                    //     field.validations.hasErr = ''
                    //     // return {field.validations, }
                    //     return
                    // })
                    // setReviewFormError(revwFormErr)
                    // console.log('default arr => ', revwForm)
                    setReviewForm(revwForm)
                    var form_obj = {}
                    res.data.dataobj.visa_form.map((review_form) => {
                        // console.log(">>>>>>>>>>>>> review_form "+review_form)
                        var remove_spcl_char = review_form.value
                        if (review_form.type == "textfield" || review_form.has_arabic) {
                            remove_spcl_char = review_form.value ? review_form.value.replace(/[^a-zA-Z0-9 ]/g, '') : "";
                        }
                        setReviewFormName(remove_spcl_char)
                        // setReviewForm({ [review_form.name]: remove_spcl_char, showTab: true })
                        if (review_form.validations.display) form_obj[review_form.name] = remove_spcl_char
                    })
                    // this.setState({ "form_obj": form_obj })
                    // console.log(form_obj)
                    setUserDetails(form_obj)
                    //console.log(">>>>>>>>>>>>> NEW JSON "+this.state.form_obj)
                    // console.log(this.state.booking_status); 

                    // if (this.state.booking_status === "employee_submitted") {

                    // } else {
                    //     this.setState({ showAgreement: true })
                    // }
                    setTimeout(() => {
                        var visa_form = res.data.dataobj.visa_form
                        visa_form.map((review_form) => {
                            var obj = {}
                            obj = review_form
                            // console.log(">>>>>>>>>>>>> NEW JSON " + obj.associated_field)
                            if (obj.associated_field != null && (obj.value != null && obj.value != "")) {
                                var remove_spcl_char = obj.value ? obj.value.replace(/[^a-zA-Z0-9 ]/g, '') : "";
                                // api_arabic_conversion(review_form, remove_spcl_char)
                            }
                        })

                    }, 1000)
                }
                else {
                    setReviewForm([])
                }
            })
            .catch(err => {
                // console.log(err);
                throw new Error("Something went wrong!", err)
            })
    }

    var definePropertyDynamically = function (_object, _propertyName, _propertyValue) {
        var config = {
            value: _propertyValue || "",
            writable: true,
            enumerable: true,
            configurable: true
        };
        Object.defineProperty(_object, _propertyName, config);
    };



    const handleFormSubmit = async () => {

        let tempReviewForm = [...reviewForm]
        let checkErrArr = tempReviewForm.filter((field, i) => {
            if (field.validations.display) { handleInputError(field.value, field, i) }
            return field
        })
        // console.log("branch_id", branch_id)
        var hasErrorFound = false;
        // console.log('country', country, city)
        // validate country and city 
        // hasErrorFound = validateCountryCity()

        for (var i = 0; i < checkErrArr.length; i++) {
            if (checkErrArr[i].validations.hasErr == true) {
                hasErrorFound = true;
                // console.log('some error', checkErrArr[i])
                return;
            }
        }
        if (!hasErrorFound) {
            // userDetails is an Enquiry form object
            // console.log('form data => ', userDetails)
            let select_visa_offer = JSON.parse(localStorage.getItem('selected_visa_offer'))
            // console.log("adult_service_fee",select_visa_offer?.fees[select_visa_offer?.visa_currency]?.adult_service_fee )
            // console.log('start date =>', moment(select_visa_offer?.journey_start_date).format("DD-MM-YYYY"))
            try {
                const res = await axios.post('/visa/submitStickerVisaApplication', {
                    "user_id": localStorage.getItem('user_id'),
                    "host": localStorage.getItem('host'),
                    "application_title": select_visa_offer?.visa_title,
                    "origin": localStorage.getItem('origin'),
                    "nationality": localStorage.getItem('nationality'),
                    "travelling_to": localStorage.getItem('travellingToCioc'),
                    "travelling_to_country": localStorage.getItem('travelling_to_country'),
                    "travelling_to_identity": localStorage.getItem('travelling_to_identity'),
                    "visa_id": localStorage.getItem('visa_id'),
                    "visa_type": localStorage.getItem('visa_type'),
                    "visa_entry_type": localStorage.getItem('entry_type'),
                    "visa_processing_type": localStorage.getItem('process_flow'),
                    "visa_category": select_visa_offer?.category,
                    "total_days": select_visa_offer?.duration_days,
                    "duration_type": select_visa_offer?.duration_type,
                    "journey_start_date": moment(select_visa_offer?.journey_start_date).format("YYYY-MM-DD"),
                    "journey_end_date": moment(select_visa_offer?.journey_end_date).format("YYYY-MM-DD"),
                    "visa_embassy_fees": select_visa_offer?.fees[select_visa_offer?.visa_currency]?.adult_govt_fee,
                    "visa_service_fees": select_visa_offer?.fees[select_visa_offer?.visa_currency]?.adult_service_fee,
                    "visa_currency": select_visa_offer?.visa_currency,
                    "user_type": "customer",
                    // "processing_city": country,
                    // "processing_country": city,
                    "visa_form": { ...userDetails }
                })
                if (res.data?.data == 'success') {
                    console.log('Form is submitted successfully!')
                    history.push({
                        pathname: '/new-visa/enquiry-form/successfull',
                        state: {
                            reference_num: res.data?.dataobj?.application_reference_code
                        }
                    })
                }


            } catch (err) {
                console.log(err)
                // throw new Error("Something went wrong!", err)
            }
        }

    }






    const handleInputChange = (name, value, index) => {
        // console.log("index", reviewForm[index])
        let data = [...reviewForm];
        data[index].value = value
        // console.log('index', data)
        setReviewForm(data);
    }
    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    const handleInputError = (value, item, index) => {
        let errArr = [...reviewForm]

        if (value !== "" && item?.name == "email") {
            if (value !== "" && !validateEmail(value)) {
                console.log('err')
                errArr[index].validations.hasErr = true
                errArr[index].validations.errMsg = "Please enter a valid email address."
                setReviewForm(errArr)
            } else {
                errArr[index].validations.hasErr = false
                errArr[index].validations.errMsg = ""
                setReviewForm(errArr)
            }
        } else if (item.validations.mandatory && value == '') {
            errArr[index].validations.hasErr = true
            errArr[index].validations.errMsg = "This field is required"
            setReviewForm(errArr)
        } else if (item.validations.mandatory && item.validations.min_length > value.length) {
            errArr[index].validations.hasErr = true
            errArr[index].validations.errMsg = "Min length should be greater than " + item.validations.min_length
            setReviewForm(errArr)
        }else if ((item.name === 'contact_number' && item.validations.mandatory) &&  value.length > 20) {
            errArr[index].validations.hasErr = true
            errArr[index].validations.errMsg = "Max length should be less than " + 20
            setReviewForm(errArr)
        }
        else {
            errArr[index].validations.hasErr = false
            errArr[index].validations.errMsg = ""
            setReviewForm(errArr)

        }
    }

    const FieldRender = (card, i) => {
        // definePropertyDynamically(userDetails, card.name, new Date())

        switch (card.type) {
            case 'textField':
                return card.validations?.display && TextFieldRender(card, i)
            case 'dateControl':
                return card.validations?.display && DateFieldRender(card, i)
            case 'dropdown':
                return card.validations?.display && DropdownRender(card, i)
            default:
                console.log("Exception :", card.type)
                break;
        }
    }

    const TextFieldRender = (item, i) => {
        return <MDBCol size="12" md='6' lg="4" className="" key={i} style={{ height: '8vh', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }} >
            <div style={{ width: '100%' }}>

                <TextField
                    name={item.name}
                    style={{ width: '100%' }}
                    inputProps={(['first_name', 'last_name', 'occupation', 'purpose_of_visit'].includes(item.name)) && { style: { textTransform: "uppercase" } }}
                    value={item?.value}
                    label={item.label}
                    error={item.validations.hasErr == true && item.validations.mandatory}
                    required={item.validations.mandatory}
                    onInput={e => handleInputError(e.target.value, item, i)}
                    disabled={item.validations.read_only}
                    // onChange={(e) => { definePropertyDynamically(userDetails, e.target.name, e.target.value); console.log("User Details :", userDetails) }}
                    onChange={(e) => {
                        const re = /^[0-9\b]+$/;
                        if (item.validations?.isDigit) {
                            if (e.target.value === '' || re.test(e.target.value)) {
                                handleInputChange(e.target.name, e.target.value, i);
                                definePropertyDynamically(userDetails, item.name, e.target.value)
                            }
                        }
                        else {
                            handleInputChange(e.target.name, e.target.value, i);
                            if (['first_name', 'last_name', 'occupation', 'purpose_of_visit'].includes(item.name)) {
                                definePropertyDynamically(userDetails, item.name, e.target.value.toUpperCase())
                            } else {
                                definePropertyDynamically(userDetails, item.name, e.target.value)
                            }
                            // definePropertyDynamically(userDetails, item.name, e.target.value)
                        }
                    }}
                />
                {item.validations.hasErr == true ? <small style={{ color: 'red' }}> {item.validations.errMsg}</small> : <small >&nbsp;</small>}
            </div>

        </MDBCol>

    }

    const DateFieldRender = (item, i) => {
        return <MDBCol size="12" md='6' lg="4" key={i} className="" style={{ height: '8vh', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }} >
            <div style={{ width: '100%' }}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        disableFuture={item.validations.when === "before"}
                        label={item.label}
                        className="w-100"
                        variant="inline"
                        // format="YYYY-MM-DD"
                        format="dd-MM-yyyy"
                        id={item.name}
                        required={item.validations?.mandatory}
                        onInput={e => handleInputError(e, item, i)}
                        // value={moment(`${userDetails[item.name]}`).toISOString()}
                        value={item.value}
                        disabled={item.validations.read_only == true}
                        style={{ width: '100%' }}
                        autoOk
                        InputProps={{ readOnly: true }}
                        onChange={(e, value) => {
                            let dateValue = value
                            handleInputChange(item.name, e, i);
                            definePropertyDynamically(userDetails, item.name, moment(dateValue, "DD-MM-YYYY").format('YYYY-MM-DD'))
                            // console.log(moment(dateValue, "DD-MM-YYYY").format('YYYY-MM-DD'))
                        }}
                    // onChange={(date, value) => { definePropertyDynamically(userDetails,item.name, value); console.log("User Details :", item.name , " =>", userDetails) }}
                    />
                </MuiPickersUtilsProvider>
                {item.validations.hasErr == true ? <small style={{ color: 'red' }}> {item.validations.errMsg}</small> : <small >&nbsp;</small>}
            </div>
        </MDBCol >
    }

    const DropdownRender = (item, i) => {
        return <MDBCol size="12" md='6' lg="4" key={i} className="" style={{ height: '8vh', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' }} >
            <div style={{ width: '100%' }}>

                <Autocomplete
                    name={item.name}
                    value={item?.value}
                    options={item.options.map((i) => i)}
                    getOptionLabel={option => option}
                    renderInput={
                        (params) => <TextField {...params} label={item.label} />
                    }
                    style={{ width: '100%' }}
                    onInput={(e, newValue) => handleInputError(newValue, item, i)}
                    // onChange={(e, newValue) => { definePropertyDynamically(userDetails, e.target.name, newValue);; console.log("User Details :", userDetails) }}
                    onChange={(e, newValue) => {
                        handleInputChange(item.name, newValue, i);
                        definePropertyDynamically(userDetails, item.name, newValue)
                    }}
                    disabled={item.validations.read_only === true}
                />
                {item.validations.hasErr == true ? <small style={{ color: 'red' }}> {item.validations.errMsg}</small> : <small >&nbsp;</small>}
            </div>

        </MDBCol>
    }

    return (
        <div>
            {/* <VisaeroJumbotron jumbotrontext='Apply New Visa' /> */}
            <div className="mt-4">

                <section>
                    <div className='mt-4'>
                        <b>
                            <MDBCardTitle className='text-white'>Enquiry Form</MDBCardTitle>
                        </b>
                        <MDBCard>
                            <MDBCardBody>
                                <MDBContainer fluid>
                                    <MDBRow>
                                        {reviewForm.length > 0 && reviewForm.map(FieldRender)}
                                    </MDBRow>
                                    <MDBRow style={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                                        <MDBBtn disabled={isDisabled} color="none" style={{ color: 'white', backgroundColor: localStorage.getItem('brand_color'), fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} onClick={handleFormSubmit}>Proceed</MDBBtn>
                                    </MDBRow>
                                </MDBContainer>
                            </MDBCardBody>
                        </MDBCard>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default EnquiryForm